// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c75aa9ad","455":"081afe0e"}[chunkId] + ".chunk.js";
};